import React from 'react';
import { buttonClasses } from './buttonStyles';

const PrimaryButton = ({ children, size = 'md', className = '', ...props }) => {
  return (
    <button {...props} className={buttonClasses("bg-blue-600 text-white hover:bg-blue-700", size, className)}>
      {children}
    </button>
  );
};

export default PrimaryButton;
